import request from '@/utils/request'

/**
 * 获取微信登录二维码
 * @returns {Promise} 返回包含 qrCodeUrl、sceneId、expireSeconds、state 的响应
 */
export function getWechatQrCode() {
  return request({
    url: '/api/frontend/wechat/qr-code',
    method: 'get'
  })
}

// 2. 查询微信登录状态
// GET /api/frontend/wechat/login-status
export function getWechatLoginStatus(sceneId) {
  return request({
    url: '/api/frontend/wechat/login-status',
    method: 'get',
    params: {
      sceneId
    }
  })
}

// 3. 绑定手机号 (微信登录后)
// POST /api/frontend/wechat/bind-phone
export function wechatBindPhone(data) {
  return request({
    url: '/api/frontend/wechat/bind-phone',
    method: 'post',
    data
  })
}

// 4. 发送绑定手机号验证码
// POST /api/frontend/wechat/bind-phone/sms
export function sendWechatBindSmsCode(data) {
  return request({
    url: '/api/frontend/wechat/bind-phone/sms',
    method: 'post',
    data
  })
}

// 5. 获取H5微信OAuth授权URL
// GET /api/frontend/wechat/h5-oauth-url
export function getWechatH5OAuthUrl(redirectUri) {
  return request({
    url: '/api/frontend/wechat/h5-oauth-url',
    method: 'get',
    params: {
      redirect_uri: redirectUri
    }
  })
}

// 6. H5微信OAuth回调处理
// GET /api/frontend/wechat/h5-callback
export function wechatH5Callback(code, state) {
  return request({
    url: '/api/frontend/wechat/h5-callback',
    method: 'get',
    params: {
      code,
      state
    }
  })
}
